import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {ImageProps} from 'app/utilities/ImageProps';
import classNames from 'classnames';

export type ContactUsTabProps = {
  title: string;
  icon: ImageProps;
  active: boolean;
  onSelect(): void;
};

const ContactUsTab = ({title, icon, active, onSelect}: ContactUsTabProps) => (
  <a className={classNames('ContactUsTab', {active})} onClick={onSelect}>
    <Image className='ContactUsTab__icon' {...icon} />
    <span className='ContactUsTab__title'>{title}</span>
  </a>
);

export default ContactUsTab;
